module.exports = __webpack_public_path__ + "static/media/9.640b4932.JPG";